import { formatNumber } from "chart.js/helpers";

/** Label for each tab key (from API tabs). Tabs list comes from API; this is only for display. */

export const getMetricLabelByKey = (metricKey) =>
  (metricKey && formatTabKeyAsLabel(metricKey)) ?? metricKey;

function formatTabKeyAsLabel(key) {
  if (!key || typeof key !== "string") return key;
  return key
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
}

const COIN_METRICS = ["total_coins", "t3coin"];

export const formatMetricCurrentValue = (metricKey, value) => {
  const isCoinsMetric = COIN_METRICS.includes(metricKey);
  return Intl.NumberFormat("en-US", {
    minimumFractionDigits: isCoinsMetric ? 0 : 2,
    maximumFractionDigits: isCoinsMetric ? 0 : 2,
  }).format(Number(value || 0));
};

/**
 * Format percentage change for display.
 * @param {number|null|undefined} pctChange - Percentage change value
 * @param {object} options
 * @param {boolean} [options.displaySign=true] - When true, show "+" or "-" in the number; when false, number has no sign (only the icon indicates direction)
 * @returns {{ text: string, isPositive: boolean } | null}
 */
export const formatMetricPercentage = (pctChange, options = {}) => {
  const { displaySign = true } = options;
  if (pctChange == null || Number.isNaN(Number(pctChange))) return null;
  const num = Number(pctChange);
  const valueToFormat = displaySign ? num : Math.abs(num);
  const numericPart = valueToFormat.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  const formatted = displaySign && num > 0 ? `+ ${numericPart} %` : `${numericPart} %`;
  return { text: formatted, isPositive: num >= 0 };
};

// Resolve CSS variable for Chart.js (Canvas doesn't support CSS vars)
export const primaryColor = getComputedStyle(document.documentElement)
  .getPropertyValue('--COLOR-PRIMARY').trim() || '#FD6F27';

export const chartOptions = ({
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: { display: false },
    title: { display: false },
    tooltip: {
      enabled: true,
      mode: "nearest",
      intersect: false,
      callbacks: {
        label: function (context) {
          const value = context.raw;
          return `${context.dataset.label}: ${formatNumber(
            value,
            "en-US",
            "decimal",
            2
          )}\n`;
        },
      },
      backgroundColor: "#25252F",
      titleFont: { family: "Poppins-regular", size: 16, weight: "bold" },
      bodyFont: { family: "Poppins-regular", size: 14 },
      padding: 20,
      displayColors: true,
    },
    datalabels: { display: false },
  },
  scales: {
    y: {
      beginAtZero: true,
      ticks: {
        callback: function (value) {
          if (value >= 1000) {
            return value / 1000 + "k";
          } else {
            return value;
          }
        },
      },
    },
  },
  interaction: {
    mode: "index",
    intersect: false,
    axis: "x",
  },
});